import React from 'react'
import { Col, Label, Row as RowNormal } from 'reactstrap'
import styled from 'styled-components'
import moment from '../../../../lib/moment.js'
import NumberFormat from 'react-number-format'
import get from 'lodash/get'
import find from 'lodash/find'
import clone from 'lodash/clone'
import shortid from 'shortid'
import { StickyTable, Row, Cell } from 'react-sticky-table'
import 'react-sticky-table/dist/react-sticky-table.css'
import TrashDefault from '../../../../static/images/trash-default.svg'
import TrashHover from '../../../../static/images/trash-hover.svg'
import { FONTS } from '../../../../constants'

export default class OtherCostTable extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)) return false
    return true
  }

  filterOther = (element) => {
    const search_other = get(this.props, 'search_other', '')
    if (search_other !== '' && element) {
      const cost_name = element.cost_name.toLowerCase()
      return cost_name.includes(search_other.toLowerCase())
    } return element
  }

  generateMonth = (start_date, end_date) => {
    const months = []
    if (start_date !== '' && end_date !== '') {
      while (moment(start_date).isSameOrBefore(moment(end_date), 'month')) {
        months.push({ year: moment(start_date).format('YYYY'), month: moment(start_date).format('MMMM') })
        start_date = moment(start_date).add(1, 'month')
      }
    }
    const addedMonths = []
    if (months.length < 12) {
      for (let i = 0; i < 12 - months.length; i++) {
        addedMonths.push({ year: '', month: '' })
      }
    }
    return [...months, ...addedMonths]
  }

  generateOtherCost = (months, other_cost) => {
    const newOtherCosts = []
    let newMonths = []
    for (let i = 0; i < other_cost.length; i++) {
      const temp_other_cost = clone(other_cost[i])
      for (let j = 0; j < months.length; j++) {
        const temp = find(temp_other_cost.cost_month, {
          month: `${months[j].year}-${moment().month(months[j].month).format('MM')}`,
        })
        if (temp === undefined) {
          newMonths.push({
            month: `${months[j].year}-${moment().month(months[j].month).format('MM')}`,
            cost: 0,
          })
        } else newMonths.push(temp)
      }
      temp_other_cost.cost_month = newMonths
      newOtherCosts.push(temp_other_cost)
      newMonths = []
    }
    return newOtherCosts
  }

  renderHeader = (year, month) => {
    return (
      <StickyMonth>
        <MonthHead>{`${month.substring(0, 3)} ${year}`}</MonthHead>
      </StickyMonth>
    )
  }

  renderDetail = (cost_month, m, other_cost_key, month_key) => {
    const editOtherCost = get(this.props, 'editOtherCost')
    const handleChangeOtherCost = get(this.props, 'handleChangeOtherCost')
    const findMonth = find(cost_month, {
      month: `${m.year}-${moment().month(m.month).format('MM')}`,
    })
    if ((m.year !== '' && m.month !== '') || (m.year === '' && m.month !== '')) {
      return (
        <NumberField
          name="cost_month"
          disabled={!editOtherCost}
          value={findMonth.cost}
          allowEmptyFormatting={ true }
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale={true}
          onBlur={(e) => {
            // e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
            handleChangeOtherCost(e, other_cost_key, month_key)
          }}
        />
      )
    }
    return null
  }

  renderName = (other_cost, other_cost_key) => {
    const deleteOtherCost = get(this.props, 'deleteOtherCost')
    const editOtherCost = get(this.props, 'editOtherCost')
    return (
      <StickyCol>
        <RowNum noGutters>
          <ColNum md={9}>
            <DataText>{other_cost.cost_name}</DataText>
          </ColNum>
          <ColNum md={3}>
            <Trash
              onClick={
                editOtherCost ?
                  () => deleteOtherCost(other_cost_key)
                  : () => { }
              }
              edit={editOtherCost}
            />
          </ColNum>
        </RowNum>
      </StickyCol>
    )
  }

  render() {
    const { hideHeader } = this.props
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && rSelected === 1
    const months = this.generateMonth(get(projectByID, 'start_date'), get(projectByID, 'end_date'))
    const other_costs = this.generateOtherCost(months, !isPresale ? get(this.props, 'other_costs', []) : get(presale_snapshot, 'other_costs'))
    const $other_cost_per_month = get(this.props, '$other_cost_per_month', [])
    return (
      /* eslint no-underscore-dangle: 0 */
      <WrapTable hide_header={ hideHeader }>
        { get(this.props, 'other_costs') && get(this.props, '$other_cost_per_month') && months.length > 0 &&
          <Sticky stickyHeaderCount={2}>
            <Row>
              <CellResource>
                <LabelHead>Cost Type</LabelHead>
              </CellResource>
              {
                months.map((item, i) => {
                  return (<CellYear key={ shortid() }>{this.renderHeader(item.year, item.month)}</CellYear>)
                })
              }
            </Row>
            <Row>
              <CellHead>Costs per month (฿)</CellHead>
              {
                months.map((item, i) => {
                  if ((item.year !== '' && item.month !== '') || (item.year === '' && item.month !== '')) {
                    return (<CellMonth key={ shortid() }>{ get($other_cost_per_month[i], 'cost', '0.00').toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }</CellMonth>)
                  } return (<CellMonth key={ shortid() } />)
                })
              }
            </Row>
            <RowStick>
              <CellStick />
              {
                months.map((item, i) => {
                  if ((item.year !== '' && item.month !== '') || (item.year === '' && item.month !== '')) {
                    return (<CellStick key={ shortid() } />)
                  } return (<CellStick key={ shortid() } />)
                })
              }
            </RowStick>
            {
              other_costs.filter(this.filterOther).map((r, other_cost_key) => {
                return (
                  <Row key={ shortid() }>
                    <CellName hide={ other_cost_key % 2 === 0 ? 'true' : 'false' }>
                      {this.renderName(r, other_cost_key)
                    }</CellName>
                    {
                      months.map((m, month_key) => {
                        return (
                        <CellInput key={ shortid() } hide={ other_cost_key % 2 === 0 ? 'true' : 'false' } style={{ textAlign: 'right', borderBottom: '1px solid #EEEEEE' }}>
                          {this.renderDetail(r.cost_month, m, other_cost_key, month_key)}
                        </CellInput>
                        )
                      })
                    }
                  </Row>
                )
              }
              )
            }
          </Sticky>
        }
      </WrapTable>
    )
  }
}

const RowStick = styled(Row)`
  display:none;
`
const CellStick = styled(Cell)`
  display:none;
`
const Sticky = styled(StickyTable)`
  padding: 0px !important;
  .y-scrollbar {
    height: 100% !important;
    top: 0 !important;
    ::-webkit-scrollbar {
      -webkit-appearance: none;
    }
    ::-webkit-scrollbar:vertical {
      width: 11px;
    }
    ::-webkit-scrollbar:horizontal {
      height: 11px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 8px;
      border: 2px solid white; /* should match background, can't be transparent */
      background-color: rgba(0, 0, 0, .5);
    }
  }
  .x-scrollbar {
    ::-webkit-scrollbar {
      -webkit-appearance: none;
    }
    ::-webkit-scrollbar:vertical {
      width: 11px;
    }
    ::-webkit-scrollbar:horizontal {
      height: 11px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 8px;
      border: 2px solid white; /* should match background, can't be transparent */
      background-color: rgba(0, 0, 0, .5);
    }
  }
`
const CellYear = styled(Cell)`
  min-width:180px !important;
  width:180px !important;
  background-color:#D44B49;
  border-left: 1px solid #EEEEEE;
  padding-top: 5px;
  padding-bottom: 0 !important;
  background-color:#D44B49;
`
const CellName = styled(Cell)`
  border-left: solid 1px #EEEEEE;
  border-right: solid 1px #EEEEEE;
  border-bottom: solid 1px #EEEEEE;
  background-color: ${props => props.hide === 'true' ? '#fff8f8' : '#fff'};
`
const CellHead = styled(Cell)`
  border: solid 1px #EEEEEE;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: #ffffff ;
  padding-left: 10px;
`
const CellInput = styled(Cell)`
  border-bottom: solid 1px #EEEEEE;
  background-color: ${props => props.hide === 'true' ? '#fff8f8' : '#fff'};
  vertical-align: middle;
`
const CellResource = styled(Cell)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  color: #ffffff;
  padding-left: 10px;
  height: 25px ;
  background-color:#D44B49;
`
const CellMonth = styled(Cell)`
  border-bottom: solid 1px #EEEEEE;
  border-right: solid 1px #EEEEEE;
  text-align: right;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 10px;
  background-color: #ffffff ;
`
const LabelHead = styled(Label)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  padding-top: 2% ;
  color:#ffffff;
  margin-bottom: 0 !important;
`
const MonthHead = styled.div`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  color: #ffffff;
  width: 100% ;
  text-align: right;
  padding-right: 5px ;
  background-color:#D44B49;
`
const WrapTable = styled.div`
  position: relative;
  width: 100%;
  height: ${p => (p.hide_header ? 'calc(100vh - 220px)' : 'calc(100vh - 320px)')};
  overflow-y: hidden;
  border: solid 1px #EEEEEE;
`
const NumberField = styled(NumberFormat)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  text-align:right;
  width : 80% ;
  margin: 0 10px;
  border-radius: 5px;
  border: 1px solid #CCCCCC;
  background-color: ${props => {
  const status = props.disabled
  if (status === !get(this.props, 'editOtherCost')) {
    return '#E8ECEF'
  }
  return '#FFFFFF'
  }};
`
const StickyCol = styled.div`
  width: 250px;
`
const StickyMonth = styled.div`
  background-color:#D44B49;
  width: 180px;
  color: #ffffff;
`
const DataText = styled.p`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin: 5%;
`
const RowNum = styled(RowNormal)`
  padding-top: 5px;
  padding-bottom: 5px;
`
const ColNum = styled(Col)`
  padding-left: 10px !important;
  padding-right: 0px !important;
`
const Trash = styled.div`
  background-image: ${props => {
  const edited = props.edit
  if (edited) {
    return `url(${TrashHover})`
  }
  return `url(${TrashDefault})`
}};
  background-repeat: no-repeat;
  align-self: center;
  border:0;
  width: 15px ;
  height: 15px ;
  margin-top: 10px;
  margin-right: 15px;
  float: right;
  cursor: ${props => { return props.edit ? 'pointer' : 'default' }};
`



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-other-cost/index.js